export const buildPrescriptionText = (suggestion = {}) => {
  if (!suggestion) {
    return '';
  }

  const normalizeText = (value) => (typeof value === 'string' ? value.trim() : '');
  const specieName = normalizeText(suggestion.specie?.name);
  const partName = normalizeText(suggestion.part?.name);
  const dosage = normalizeText(suggestion.dosage);
  const specieWithPart = [specieName, partName ? `(${partName})` : '']
    .filter(Boolean)
    .join(' ');

  return [specieWithPart, dosage]
    .filter(Boolean)
    .join(' ')
    .trim();
};

export default buildPrescriptionText;
